// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sxHT","left":"styles_left__1Wlbp"};